import { render, staticRenderFns } from "./PublicTablesWithImages.vue?vue&type=template&id=c0b091a2&"
import script from "./PublicTablesWithImages.vue?vue&type=script&lang=js&"
export * from "./PublicTablesWithImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports